module.exports = __webpack_public_path__ + "img/home_2.11b10ac4.png";